import * as React from "react";

import { GraphicProps } from "./types";
import zuoraLogo from "./zuoraLogo.jpeg";

const DEFAULT_SIZE = 24;

const ZuoraLogoSvg: React.FC<GraphicProps> = ({
  size = DEFAULT_SIZE,
  style,
  onClick,
}) => {
  return (
    <img
      src={zuoraLogo}
      alt="Zuora"
      width={size}
      height={size}
      style={{
        borderRadius: "50%",
        verticalAlign: "middle",
        ...style,
        cursor: onClick ? "pointer" : undefined,
      }}
      onClick={onClick}
    />
  );
};

export default ZuoraLogoSvg;
